import { useParams } from "react-router";
import { Title } from "../../utils/title";
import { DriverNavBar } from "./NavBar";
import AssetStatusHistoryGrid from "../Assets/StatusHistoryGrid";

type RouteParams = {
  driverId: string;
};

const DriverStatusHistory = () => {
  const { driverId } = useParams<RouteParams>();

  return <>
    <DriverNavBar id={driverId} currentTab="StatusHistory" />
    <Title string="Driver Status History" />
    <AssetStatusHistoryGrid endpoint={`/api/Asset/DriverStatusHistory/${driverId}`} />
  </>;
};

export default DriverStatusHistory;